module.exports = __webpack_public_path__ + "img/ascend_gold21.75e8b9ef.png";